/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveClassModuleViewModel } from "../types/SaveClassModuleViewModel.ts";
import { eCourseModalitySchema } from "./eCourseModalitySchema.ts";
import { saveClassModuleDisciplineViewModelSchema } from "./saveClassModuleDisciplineViewModelSchema.ts";

export const saveClassModuleViewModelSchema = z.object({
  description: z.string().nullish(),
  dateStart: z.string().datetime().nullish(),
  dateFinish: z.string().datetime().nullish(),
  companyId: z.number().int().nullish(),
  modality: z.optional(
    z
      .lazy(() => eCourseModalitySchema)
      .describe(
        "1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand | ",
      ),
  ),
  classStudentIds: z.array(z.number().int()).nullish(),
  disciplines: z
    .array(z.lazy(() => saveClassModuleDisciplineViewModelSchema))
    .nullish(),
}) as unknown as ToZod<SaveClassModuleViewModel>;
